/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Box, Typography } from '@mui/material';
import useCommonStyles from '../modules/aiadmin/components/common/CommonStyle';

const Loader = ({ primaryMessage, secondaryMessage, loaderStatusResponse }) => {
  const classes = useCommonStyles();
  return (
    <div>
      <Box className={loaderStatusResponse ? classes.positionChatgpt : classes.positionAiAdmin}>
        <CircularProgress className={classes.progressBarBlur} />
        {(primaryMessage || secondaryMessage) && (
          <Box className={classes.message}>
            <Typography align="center" variant="h3" color="textSecondary">
              {primaryMessage}
              <br />
              {secondaryMessage}
            </Typography>
          </Box>
        )}
      </Box>
    </div>
  );
};

Loader.defaultProps = {
  primaryMessage: null,
  secondaryMessage: null,
  loaderStatusResponse: false
};

Loader.propTypes = {
  primaryMessage: PropTypes.string,
  secondaryMessage: PropTypes.string,
  loaderStatusResponse: PropTypes.bool
};

export default Loader;
